import { useState } from "react";

interface Props {
  isCorrect: boolean;
  guiltyName: string;
  episodeTitle: string;
  episodeUrl: string;
}

export default function ShareBlock({ isCorrect, guiltyName, episodeTitle, episodeUrl }: Props) {
  const [copied, setCopied] = useState(false);

  const shareText = isCorrect
    ? `I just solved "${episodeTitle}" on Hunch. I accused ${guiltyName} — and I was right. Can you solve it? ${episodeUrl}`
    : `I just tried to solve "${episodeTitle}" on Hunch. I got it wrong — the killer was ${guiltyName}. Think you can do better? ${episodeUrl}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareText);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch {
      const el = document.createElement("textarea");
      el.value = shareText;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    }
  };

  const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`;
  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(shareText)}`;

  return (
    <div className="share-block">
      <div className="share-label">— Challenge someone</div>

      <div className="share-preview">
        <p className="share-preview-text">{shareText}</p>
      </div>

      <div className="share-buttons">
        <button className="share-btn share-btn-copy" onClick={handleCopy}>
          {copied ? "✓ Copied" : "Copy link"}
        </button>

        <a
          className="share-btn share-btn-twitter"
          href={twitterUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Post on X
        </a>

        <a
          className="share-btn share-btn-whatsapp"
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          WhatsApp
        </a>
      </div>
    </div>
  );
}
